import ContactUs from './contact-us';

export default ContactUs;
